import classNames from 'classnames';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { selectShowSelectedGroups } from 'Selector/CompaniesSelector';
import DropWrapper from 'Components/people/components/DropWrapper';
import {
  selectAllLoading, selectEndedGroups, selectSearchedGroups,
} from 'Selector/GroupsSelector';
import GroupsDisplaySkeleton from 'Components/common/skeleton/GroupsDisplaySkeleton';
import GroupsDisplayWidget from 'Components/people/components/GroupsDisplayWidget';
import { NO_GROUP_FOUND } from 'Utils/Constants';
import NoPersonsFound from 'Components/common/components/NoPersonsFound';
import { StaffBuyerGroupData } from 'Types/GroupsTypes';
import { actions as groupActions } from 'Slice/GroupsSlice';

const Wrapper = styled.div`
`;

type Props = {
  searchTerm: string
  handleView: () => void
  handleAddGroup: (group: StaffBuyerGroupData) => void
  handleRemoveGroup: (group: StaffBuyerGroupData) => void
};

const SmartAccountBuyerSearch = function SmartAccountBuyerSearch(props: Props) {
  const {
    searchTerm, handleView, handleAddGroup, handleRemoveGroup,
  } = props;
  const loading = useSelector(selectAllLoading);
  const ended = useSelector(selectEndedGroups);
  const showSelectedGroups = useSelector(selectShowSelectedGroups);
  const searchedGroups = useSelector(selectSearchedGroups);
  const dispatch = useDispatch();

  const fetchMore = () => {
    if (!showSelectedGroups && searchedGroups?.length) {
      dispatch(groupActions.getAllGroups({
        searchTerm,
        offset: searchedGroups.length,
      }));
    }
  };

  return (
    <Wrapper>
      <InfiniteScroll
        hasMore={!ended}
        dataLength={searchedGroups?.length ?? 0}
        next={fetchMore}
        loader={false}
        height="auto"
        className={classNames('groups-wrapper')}
      >
        {searchedGroups.map((group) => (
          <DropWrapper
            key={group.groupId}
          >
            <GroupsDisplayWidget
              onClickHandler={() => { }}
              groupPersona={group.groupPersonality}
              persons={group.persons}
              companies={group.companyLogos}
              groupName={group.groupName}
              groupId={group.groupId}
              personsCount={group.personsCount}
              isShared={group.groupShared}
              sharedBy={group.sharedByFirstName}
              showAddIcon
              onClickAdd={() => handleAddGroup(group)}
              onClickRemove={() => handleRemoveGroup(group)}
            />
          </DropWrapper>
        ))}
        {loading && !ended
          ? <GroupsDisplaySkeleton border /> : null}
        {searchedGroups.length < 1 && !loading
          ? (
            <div className="no-data-wrapper">
              <NoPersonsFound title={NO_GROUP_FOUND} />
              <span
                className="view-text"
                onClick={handleView}
                onKeyPress={handleView}
                role="button"
                tabIndex={0}
              >
                View Group
              </span>
            </div>
          ) : null}

      </InfiniteScroll>
    </Wrapper>
  );
};

export default SmartAccountBuyerSearch;
